<template>
  <div class="service-wrapper">
    <Title
      title="智慧服务"
      subTitle="Intelligent Care"
      @showMore="showMore"
    ></Title>
    <!-- 日周月 -->
    <div class="service-date">
      <div
        v-for="item in dateList"
        :class="currentDate === item.value ? 'choose-date' : ''"
        :key="item.value"
        class="service-date-item"
        @click="chooseDate(item.value)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 服务事项 -->
    <div class="service-container">
      <div
        class="service-container-item"
        v-for="item in itemList"
        :key="item.name"
      >
        <div class="service-container-item-value">
          {{ item.value }}
        </div>
        <div class="service-container-item-name">
          <img class="service-container-item-icon" :src="item.icon" alt />
          {{ item.name }}
        </div>
      </div>
    </div>
    <!-- 次数统计 -->
    <div class="number-statistics">
      <div>
        移动端登录次数&nbsp;<span class="number-color">{{
          serviceData.data.data.loginCount
        }}</span
        >次
      </div>
      <div>
        意见反馈次数&nbsp;<span class="number-color">{{
          serviceData.data.data.adviceCount
        }}</span
        >次
      </div>
    </div>
    <!-- 参观出入院统计 -->
    <div class="line-chart-list">
      <div id="visit"></div>
      <div id="hospital"></div>
    </div>
    <!-- 点单记录 -->
    <div class="nurse-record-con">
      <div class="record-title">
        <div class="title-con">
          <div class="icon"></div>
          <div class="title">点单记录</div>
        </div>
        <!-- <div class="more">更多</div> -->
      </div>
      <dv-scroll-board
        :config="recordConfig"
        style="width: 500px; height: 150px"
      />
    </div>
    <!-- 服务单管理 -->
    <div class="line-chart-con">
      <div class="title-item">
        <div class="title-icon"></div>
        <div>服务单管理</div>
      </div>
      <div id="trend-line-chart"></div>
    </div>
    <!-- 线上点单统计 -->
    <!-- <div class="online-order-chart-con">
      <div class="title-item">
        <div class="title-icon"></div>
        <div>
          线上点单统计<span class="number-color">{{ orderNum }}</span
          >次
        </div>
      </div>
      <div id="online-charts"></div>
    </div> -->
  </div>
</template>

<script>
import Title from "@/components/Commen/CloseTitle";
const echarts = require("echarts");
import statisticsChart from "./charts/statistics";
import inOutLineChart from "./charts/line";
import trendLineChart from "./charts/trendLine";
import { mapState, mapActions } from "vuex";
import pollingFunction from "@/utils/tools";

export default {
  components: {
    Title,
  },
  data() {
    return {
      dateList: [
        {
          name: "月",
          value: "month",
        },
        {
          name: "周",
          value: "week",
        },
        {
          name: "日",
          value: "day",
        },
      ],
      currentDate: "day",
      yearMonthStart: "2022-01",
      yearMonthEnd: "2022-05",
      branchId: 6627,
      itemList: [
        {
          name: "预约参观",
          value: "218",
          icon: require("./../../../src/assets/svgIcon/reservation.svg"),
        },
        {
          name: "访客管理",
          value: "218",
          icon: require("./../../../src/assets/svgIcon/person.svg"),
        },
        {
          name: "入院申请",
          value: "218",
          icon: require("./../../../src/assets/svgIcon/enter.svg"),
        },
        {
          name: "出院申请",
          value: "218",
          icon: require("./../../../src/assets/svgIcon/getOut.svg"),
        },
        {
          name: "入院办理",
          value: "218",
          icon: require("./../../../src/assets/svgIcon/enter.svg"),
        },
        {
          name: "出院办理",
          value: "218",
          icon: require("./../../../src/assets/svgIcon/getOut.svg"),
        },
      ],
      orderNum: 133,
      mobileLoginNum: 218,
      feedbackNum: 218,
      recordConfig: {},
    };
  },
  computed: {
    ...mapState(["serviceData"]),
  },
  async mounted() {
    if (!this.pollingRD) {
      setTimeout(() => {
        this.pollingRD = pollingFunction(this.getRecordData, 5000);
      }, 5000);
    }
    this.drawChart(this.serviceData);
  },
  methods: {
    ...mapActions(["getServiceData"]),
    showMore() {
      this.$store.commit("setServiceDrawer", true);
      this.$store.commit("setCurrentMenu", "service");
    },
    async getRecordData() {
      let json = {
        statusId: '222',
        rows: 10,
        page: 1,
        pcOrApp: 1,
      };
      let response = await this.$api.rightSideBar.listByPageBean(json);
      let data = response.data.data.rows.map((el) => {
        return [
          this.formatterDate(el.markTime),
          el.orderServeHuman,
          el.staffName,
          el.orderServeTypeName,
        ];
      });
      this.recordConfig = {
        header: ["服务时间", "服务对象", "服务人员", "服务项目"],
        rowNum: 4,
        columnWidth: [120, 80, 80],
        headerBGC: "rgba(0,0,0,0)",
        oddRowBGC: "rgba(103, 118, 137, 0.3)",
        evenRowBGC: "rgba(0,0,0,0)",
        data,
      };
    },
    async chooseDate(value) {
      if (value == this.currentDate) return;
      this.currentDate = value;
      let json = {
        callInfoDateType: this.currentDate,
        yearMonthStart: this.yearMonthStart,
        yearMonthEnd: this.yearMonthEnd,
        branchId: this.branchId,
        callInfoDate: this.getTime(),
      };
      await this.getServiceData(json);
      this.drawChart(this.serviceData);
    },
    getTime() {
      let date_ = new Date();
      let seperator1 = "-";
      let year = date_.getFullYear();
      let month = date_.getMonth() + 1;
      let strDate = date_.getDate();
      return year + seperator1 + month + seperator1 + strDate;
    },
    formatterDate(item) {
      if (!item) return "";
      return item.substr(5).substr(0, 11);
    },
    async drawChart(res) {
      this.$set(this.itemList[0], "value", res.data.data.yycgCount);
      this.$set(this.itemList[1], "value", res.data.data.fktsCount);
      this.$set(this.itemList[2], "value", res.data.data.intoCountApply);
      this.$set(this.itemList[3], "value", res.data.data.checkOutApplyCount);
      this.$set(this.itemList[4], "value", res.data.data.intoCount);
      this.$set(this.itemList[5], "value", res.data.data.checkOutCount);
      // this.onlineCharts = echarts.init(
      //   document.getElementById("online-charts")
      // );
      // let data = [
      //   { value: "19", name: "就餐" },
      //   { value: "16", name: "康复" },
      //   { value: "24", name: "照料" },
      //   { value: "14", name: "医疗" },
      //   { value: "27", name: "其他" },
      // ];
      // this.onlineCharts.setOption(statisticsChart(data));
      this.inOutVisitLineCharts = echarts.init(
        document.getElementById("visit")
      );
      let arr = res.data.data.yycg.map((el) => {
        return el.number;
      });
      let arr2 = res.data.data.fkts.map((el) => {
        return el.number;
      });
      let visitData = [arr, arr2];
      let visitName = ["预约参观", "访客管理"];
      this.inOutVisitLineCharts.setOption(inOutLineChart(visitData, visitName));
      this.inOutHospitalLineCharts = echarts.init(
        document.getElementById("hospital")
      );
      let intoArr = res.data.data.intoList.map((el) => {
        return el.number;
      });
      let intoArr2 = res.data.data.outList.map((el) => {
        return el.number;
      });
      let hospitalData = [intoArr, intoArr2];
      let hospitalName = ["入院", "出院"];
      this.inOutHospitalLineCharts.setOption(
        inOutLineChart(hospitalData, hospitalName)
      );
      this.trendLineChart = echarts.init(
        document.getElementById("trend-line-chart")
      );
      let trendData = [];
      res.data.data.serviceList.forEach((el) => {
        let arr = [];
        el.list.forEach((item) => {
          arr.push(item.typeQuantity);
        });
        trendData.push(arr);
      });
      this.trendLineChart.setOption(trendLineChart(trendData));
    },
  },
};
</script>

<style lang="scss" scoped>
.service-wrapper {
  width: 460px;
  position: relative;
  top: -30px;
}
.title-con ::v-deep .devide-line {
  margin-bottom: 3px;
}
.service-date {
  color: rgba(255, 255, 255, 0.63);
  font-size: 15px;
  display: flex;
  flex-direction: row-reverse;
  padding: 0 10px;
  .service-date-item {
    padding-left: 10px;
    cursor: pointer;
  }
}
.choose-date {
  color: rgb(237, 255, 0);
}
.number-color {
  color: rgb(237, 255, 0);
}
.service-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  .service-container-item {
    height: 70px;
    width: 105px;
    color: #fff;
    background-color: rgba(24, 24, 24, 0.6);
    margin: 5px 10px 15px 0;
    .service-container-item-value {
      font-size: 26px;
      text-align: right;
      padding: 10px 20px 0 10px;
      letter-spacing: -2px;
    }
    .service-container-item-name {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 0 15px 0 5px;

      .service-container-item-icon {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}

.number-statistics {
  position: relative;
  top: -75px;
  left: 10px;
  color: rgb(222, 246, 255);
  display: inline-block;
}

.line-chart-list {
  position: relative;
  top: -50px;
  display: flex;
}

#visit,
#hospital {
  width: 240px;
  height: 240px;
  position: relative;
  z-index: 999;
}

.nurse-record-con {
  position: relative;
  top: -80px;
  .record-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 450px;
    line-height: 30px;
    color: #fff;
    .title-con {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .icon {
      width: 24px;
      height: 24px;
      background: url("../../assets/index/title-icon.png") no-repeat center;
      background-size: contain;
      vertical-align: middle;
    }
    .more {
      color: rgb(81, 218, 239);
      font-size: 14px;
      cursor: pointer;
    }
  }
}

.online-order-chart-con {
  width: 204px;
  position: relative;
  top: -80px;
  left: 10px;
  .title-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
    font-weight: normal;
    font-family: "Microsoft Yahei", Arial, "sans-serif";
    font-size: 16px;
    writing-mode: horizontal-tb;
    .title-icon {
      width: 38px;
      height: 38px;
      border-radius: 5px;
      background-image: url("../../assets/index/fwtj.svg");
      mask: url("../../assets/index/fwtj.svg") no-repeat 50% 50%;
      -webkit-mask-size: cover;
      background-color: rgb(197, 255, 255);
      mask-size: cover;
      margin-right: 10px;
    }
  }
}
.line-chart-con {
  position: relative;
  top: -80px;
  .title-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
    font-weight: normal;
    font-family: "Microsoft Yahei", Arial, "sans-serif";
    font-size: 16px;
    writing-mode: horizontal-tb;
    .title-icon {
      width: 38px;
      height: 38px;
      border-radius: 5px;
      background-image: url("../../assets/index/fwtj.svg");
      mask: url("../../assets/index/fwtj.svg") no-repeat 50% 50%;
      -webkit-mask-size: cover;
      background-color: rgb(197, 255, 255);
      mask-size: cover;
      margin-right: 10px;
    }
  }
  #trend-line-chart {
    width: 100%;
    height: 230px;
  }
}
#online-charts {
  width: 200px;
  height: 200px;
  position: relative !important;
  top: -20px;
}
</style>
